export const COLORS = {
    Blue: "#0000FF",
    RoyalBlue: "#4169E1",
    CornflowerBlue: "#6495ED",
    ClearBlue: "#41b5e6",
    ClearBlue50: "#41b5e650",
    ClearBlue10: "#41b5e610",
    Black: "#000",
    Black90: "#0009",
    Black95: "#00000095",
    Black50: "#0005",
    Gray: "#6e7076",
    Red: "#ff0000",
    Green: "#00FF00",
    White: "#FFFFFF",
    OrangePentagro1: "#ff5f00",
    OrangePentagro2: "#ff2200",
    OrangePentagro3: "#ffb373",
    BluePentagro1: "#00A39F",
    BluePentagro2: "#179E91",
    BluePentagro3: "#2E9A82",
    Cana: "#b5b076",
    Caldo: "#683604",
    Agua: "#005985",
    Bagaco: "#321400",
    Energia: "#2a8d77",
    Vapor: "#861313",
    Levedura: "#fccc9e",
    Etanol: "#5d9065",
    Acucar: "#cf9846",
    ÁguaAmarela :  "#F2F5A9",
    Frit : "#B45F04",
    Bagaço : "#AEB404", 
    SucoPolpa : "#F5DA81", 
    Core : "#D0FA58",
    Condensado : "#0431B4",
    Polpa : "#FFFF00",
    SucoFiltrado : "#FFBF00",
    Células : "#F5F6CE",
    Defeitos : "#000000", 
    SucoSemCélulas : "#FACC2E", 
    CoreWash : "#81F79F", 
    Wesus : "#2E9AFE",
    PulpWash : "#F3F781", 
    SucoEvaporação :  "#FE9A2E",
    SucoCentrifugado : "#F7D358",
    PolpaCentrifugada : "#F4FA58", 
    PolpaLavada : "#F7FE2E",
    OilPhase :  "#FAAC58",
    OilPhasePlus : "#F5D0A9", 
    WaterPhase :  "#81DAF5", 
    FCOJ : "#FF8000", 
    NFC : "#DF7401", 
    Ração : "#61380B" 
}